// extracted by mini-css-extract-plugin
module.exports = {"trophyDetail__container":"TrophyDetail_trophy-detail__container__5k5c6","trophyDetail__title":"TrophyDetail_trophy-detail__title__ldABw"};